<div class="feature-popup" [class.feature-popup_shown]="isShown" *ngIf="isRendered && featurePopup">
	<div class="feature-popup-text" [innerHTML]="safeHtml"></div>
	<button type="button" class="feature-popup-close" title="Close" (click)="close()">
		<i class="far fa-times"></i>
	</button>
</div>
